import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const Visibility = z.enum(["Hidden", "Visible"]);
export const VisibilityValue = Visibility;
export const VisibilityTokenData = tokenAliasOrValue(VisibilityValue);
